<template>
  <b-form class="mb-3" @submit.prevent>
    <b-form-group label="في أي محور ترغب بالمشاركة :">
      <b-form-checkbox-group
        class="topics-select"
        v-model="form.participating_fields"
        :options="topicsOptions"
        name="chceckboxes-participating_field"
        multiple
        id="chceckboxes-topics"
      />
    </b-form-group>
    <form-select
      label="اليوم المناسب للحضور"
      id="disability-type"
      ref="disability-type"
      rules="required"
      :options="getDayOptions()"
      v-model="form.participating_day"
      :getOptionLabel="(x) => x.text"
      :reduce="(x) => x.value"
    />

    <form-select
      label="التوقيت المناسب للحضور"
      id="attendance-time"
      :options="['10:00 - 12:00', '12:30 - 14:30']"
      rules="required"
      v-model="form.participating_time"
    />

    <b-form-group label="هل أنت من ذوي الإعاقة ؟">
      <b-form-radio-group
        v-model="form.is_disabled"
        :options="yesNoOptions"
        name="radios-is_disabled"
      />
    </b-form-group>
    <form-select
      v-if="form.is_disabled"
      label="نوع الإعاقة"
      id="disability-type"
      ref="disability-type"
      rules="required"
      :options="disabilityOptions"
      v-model="form.disability_type"
    />
    <b-form-group
      label="هل لديك أفكار تساعد  في إغناء المحور الذي قمت بالتسجيل عليه ؟"
    >
      <b-form-radio-group
        v-model="form.has_beneficial_ideas"
        :options="yesNoOptions"
        name="radios-has_beneficial_ideas"
      />
    </b-form-group>
    <b-form-group label="هل أنت مستعد للالتزام بالحضور والتفاعل في الجلسات ؟">
      <b-form-radio-group
        v-model="form.commitment"
        :options="yesNoOptions"
        name="radios-commitment"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import FormSelect from "@/components/form-select";
import FormDatepicker from "@/components/form-datepicker/index.vue";

import FormMask from "@/components/form-mask";
import {
  BForm,
  BFormCheckboxGroup,
  BFormRadioGroup,
  BFormGroup,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
export default {
  props: ["value"],
  components: {
    FormMask,
    BForm,
    BFormCheckboxGroup,
    BFormGroup,
    BListGroup,
    BListGroupItem,
    FormSelect,
    BFormRadioGroup,
    FormDatepicker,
  },
  data() {
    return {
      disabilityOptions: ["بصرية", "سمعية", "نطقية", "حركية"],
      yesNoOptions: [
        { text: "نعم", value: true },
        { text: "لا", value: false },
      ],
      topicsOptions: [
        { text: "تحليل نقاط الضعف والقوة والتحديات والفرص", value: 1 },
        {
          text: "مالية المنظمات غير الحكومية (التمويل – الحوكمة – المصادر – الآليات – الأنظمة  المالية والمحاسبية).",
          value: 2,
        },
        {
          text: "تشاركية العمل وبناء التحالفات",
          value: 3,
        },
        {
          text: "التصنيف المعياري الحالي (الأنشطة والتخصصات – الواقع – الطموح – تعريف -  تقييم -  قياس الأثر – الفئات المستهدفة - آليات الاستهداف) انطلاقاً من الأنشطة على الأرض.",
          value: 4,
        },
      ],
    };
  },
  methods: {
    getDayOptions() {
      var options1 = [
        {
          text: "الأحد 16-7-2023",
          value: "16-7-2023",
        },
        {
          text: "الاثنين 17-7-2023",
          value: "17-7-2023",
        },
      ];
      var options2 = [
        {
          text: "الأحد 23-7-2023",
          value: "23-7-2023",
        },
        {
          text: "الاثنين 24-7-2023",
          value: "24-7-2023",
        },
      ];
      var options3 = [
        {
          text: "الأربعاء 26-7-2023",
          value: "16-7-2023",
        },
      ];
      if ([1, 11, 12, 13].includes(this.form.residence_id)) return options1;
      if ([2, 4, 8, 9, 10, 14].includes(this.form.residence_id))
        return options2;
      if ([5, 6, 3, 7].includes(this.form.residence_id)) return options3;
    },
  },

  computed: {
    form: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style lang="scss">
.topics-select {
  .custom-checkbox {
    margin-top: 1.5rem;
  }
}
</style>
